export const items = (state) => {
  return state.list
}
